module.exports = __webpack_public_path__ + "img/xrpkrw.9f413767.png";